import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateUserProfilePayload = {
  first_name?: string;
  last_name?: string;
  email?: string;
  username?: string;
  avatar?: string | null;
  timezone?: string;
  id: number;
};
type UpdateUserProfileResponse = any;

export const updateUserProfile = async (
  payload: UpdateUserProfilePayload
): Promise<UpdateUserProfileResponse> => {
  try {
    const body = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => key !== 'id' && value !== undefined
      )
    );

    const { data } = await apiService.patch<UpdateUserProfileResponse>(
      `/users/${payload.id}/`,
      body
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
